<template>
  <div>


    <b-alert v-if="isOnline == false" show variant="danger">NB! Du er ikke tilkoblet nett. Lusetelling blir lagret i offline modus</b-alert>

      <b-alert v-if="isOnline == true && offlineData == true" show dismissible variant="success">
        <h4 class="alert-heading">Klar til å laste opp data</h4>
        <p>
          Du er online og kan nå laste opp offline data
        </p>
        <hr>

        <b-button class="mb-3 mr-2" v-if="isOnline == true && offlineData == true" variant="outline-success" @click="uploadOfflineStorage()">Last opp</b-button>     
        <!-- <b-button class="mb-3" v-if="offlineData == true" variant="outline-danger" @click="clearOfflineStorage()">Fjern offline data</b-button> -->

    </b-alert>

    <b-row>
      <b-col md="6"> 
        <h4 class="font-weight-bold">Lusetelling - Uke {{licecount.week}}  </h4> 
        
        <div class="mute" v-if="licecount.customer_company != null">{{licecount.customer_company.name}} - {{licecount.site.number}} {{licecount.site.name}} 
        <br>
        <span class="mute mt-1" >Merd {{licecount.cage}}: {{licecount.type }} <span v-if="licecount.description != null"> - {{licecount.description }}</span> </span>
        </div>
     
        

      </b-col>

       <b-col md="6">
        <div class="text-right mb-3">

          <b-row class="float-right mr-1">
            <!-- <b-form-checkbox class="mt-2 mr-3">
              Send ordrebekreftelse
            </b-form-checkbox> -->

            <b-button class="mr-2" variant="default" @click="goBack()">Avbryt</b-button>

            <b-dropdown right split variant="primary" text="Lagre" @click="saveLicecount()">
              <b-dropdown-item @click="openReport()">Lag rapport</b-dropdown-item>
              <b-dropdown-item @click="editLicecount()">Endre</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="deleteLicecount()">Slett</b-dropdown-item>
            </b-dropdown>

          </b-row>

        </div>
      </b-col>
    </b-row>

    <br>

    <b-row>
 
      <b-col md="12" lg="12" xl="12">

        <!-- Stats cards -->

          <b-row>

            <b-col>
              <b-card>
               <label>Antall fisk</label><h3>{{ details.fish.length }}</h3>
               </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Hunnlus</label><h3>{{ details.lice_female | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Bevegelige</label><h3>{{ details.lice_moving | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Fastsittende</label><h3>{{ details.lice_persist | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Skottelus</label><h3>{{ details.lice_skott | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <!-- <b-col>
              <b-card>
               <label>Velferd</label><h3>{{ details.wellfare  | numeralFormat("0,0[.]0") }} </h3>
               </b-card>
            </b-col> -->


          </b-row>
          <br>



          <!-- Fish lice count -->
     
          <b-row>

              
              <b-col md="6" lg="6" xl="5">
                <b-card bg-variant="light">
                <h6 class="text-center">Lusetelling</h6>

                <b-row>

                  <!-- <b-col>
                    <label>Fisk nummer</label>
                    <b-form-input tabindex="0" v-model.number="fish.number" disabled type="number" placeholder="Fisk nummer"></b-form-input>
                  </b-col> -->

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Hunnlus</label>
                    <br>
                      <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_female" vertical></b-form-spinbutton>
                    
                  </b-col>
          
                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Bevegelige</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_moving" vertical></b-form-spinbutton>
                 
                  </b-col>

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Fastsittende</label>
                    <br>
                       <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_persist" vertical></b-form-spinbutton>
                  </b-col>

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Skottelus</label>
                    <br>
                       <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_skott" vertical></b-form-spinbutton>
                  </b-col>
                         
                </b-row>

                </b-card>
              </b-col>



              <b-col md="6" lg="6" xl="7">
                <b-card bg-variant="light">
                <!-- Fish welfare -->
                <h6 class="text-center">Velferdsregistreringer (0-3)</h6>

                <b-row>

                  <b-col md="4" lg="3" class="text-center">
                    <label class="text-center">Risttap</label>
                      <br>
                      <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_shelloss" vertical></b-form-spinbutton>
                      
                  </b-col>
                                
                  <b-col md="4" lg="3" class="text-center">
                    <label class="text-center">Rødbuk</label>
              <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_redbelly" vertical></b-form-spinbutton>
                   
                  </b-col>

                  <b-col md="4" lg="3" class="text-center">
                    <label class="text-center">Sår</label>
                <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_wounds" vertical></b-form-spinbutton>
                   
                  </b-col>

                  <b-col md="4" lg="3"   class="text-center">
                    <label class="text-center">Øyeblødning</label>
                   <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_eyebleed" vertical></b-form-spinbutton>
                     
                  </b-col>

                  <b-col md="4" lg="3"  class="text-center">
                    <label class="text-center">Finner</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_fin" vertical></b-form-spinbutton>
                    
                  </b-col>

                  <b-col md="4" lg="3"   class="text-center">
                    <label class="text-center">Snutesår</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_nosewounds" vertical></b-form-spinbutton>
               
                  </b-col>

                  <b-col md="4" lg="3"  class="text-center">
                    <label class="text-center">Gjellelokkskade</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_gillwounds" vertical></b-form-spinbutton>
                  </b-col>
                 
                  <b-col md="4" lg="3"   class="text-center">
                    <label class="text-center">Gjelleblødning</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_gillbleed" vertical></b-form-spinbutton>
                  </b-col>
 
                </b-row>

                </b-card>
              </b-col>

          </b-row>

            <b-form-input tabindex="4" v-model.number="fish.note" id="inline-form-input-name" class="mt-3 mb-2 mr-sm-2 mb-sm-0" placeholder="Notat"></b-form-input>

            <b-input-group class="mt-3 mr-sm-2 mb-sm-0">
              <b-button tabindex="5" class="mb-3" block @click="addFish()" variant="primary">Legg til</b-button>
            </b-input-group>



            <!-- Fish table -->

            <b-card>
            <h6>Telling oversikt</h6>
            <b-table class="mt-3" v-if="this.details.fish[0] != null" striped hover :fields="fishFields" :items="this.details.fish">

              <template v-slot:cell(number)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell(cages)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

     
              <template v-slot:cell(fishcount)="data">
                {{ data.value | numeralFormat("0,0[.]") }}
              </template>

              <template v-slot:cell(wellfare)="data">

                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 1" variant="light">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 2" variant="warning">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 3" variant="danger">Risttap</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 1" variant="light">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 2" variant="warning">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 3" variant="danger">Rødbuk</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 1" variant="light">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 2" variant="warning">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 3" variant="danger">Sår</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 1" variant="light">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 2" variant="warning">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 3" variant="danger">Øyeblødning</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 1" variant="light">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 2" variant="warning">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 3" variant="danger">Finner</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds == 1" variant="light">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 2" variant="warning">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 3" variant="danger">Snutesår</b-badge>

                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds == 1" variant="light">Gjellelokkskade</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds  == 2" variant="warning">Gjellelokkskade</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds  == 3" variant="danger">Gjellelokkskade</b-badge>

                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed == 1" variant="light">Gjelleblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed  == 2" variant="warning">Gjelleblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed  == 3" variant="danger">Gjelleblødning</b-badge>

              </template>

              <template v-slot:cell(actions)="data">
                <b-button variant="primary" size="sm" @click="removeFish(data.item)">Fjern</b-button>
              </template>

            </b-table>

            </b-card>
  
      </b-col>

    </b-row> 



    <!-- New Licecount modal -->

      <b-modal
        id="editLicecountModal"
        title="Endre lusetelling"
      >

      <b-row>
        <b-col>

          <label>Uke</label>
          <b-form-input class="mb-3" v-model="licecount.week" placeholder="Ukenummer" type="number"></b-form-input>

        </b-col>

        <b-col>

          <label>År</label>
          <b-form-input class="mb-3" v-model="licecount.year" placeholder="År" type="number"></b-form-input>

        </b-col>

      </b-row>

          <label>Ordre</label>
          <v-select class="mb-3" v-model="order" :options="orders"  @input="changeOrder(order)"></v-select>
     

          <!-- <label>Kunde</label>
          <vue-typeahead-bootstrap class="mb-3" v-model="queryCompany" :ieCloseFix="false" :data="companies"
                      :serializer="(item) => item.name" @hit="customer_company = $event" placeholder="Søk kunde"
                      @input="lookupCompanies" />

          <label>Lokasjon</label>
          <vue-typeahead-bootstrap class="mb-3" v-model="querySites" :ieCloseFix="false" :data="sites"
                  :serializer="(item) => item.number + ' - ' + item.name" @hit="site = $event"
                  placeholder="Søk lokaliteter" @input="lookupSites" /> -->


          <label>Merd</label>
          <b-form-input class="mb-3" v-model.number="licecount.cage" placeholder="Merd"></b-form-input>

          
          <label>Telling type</label>
          <b-form-select class="mb-3" v-model="licecount.type" :options="typeLicecount"></b-form-select>

          <label>Beskrivelse</label>
          <b-form-input class="mb-3" v-model.number="licecount.description" placeholder="Beskrivelse"></b-form-input>


        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="updateLicecount()"
            >
              Lagre
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeLicecount()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
      </b-modal>



    <!-- Report - Generate PDF with preview -->
      <b-modal
        id="reportLicecountModal"
        title="Rapport lusetelling"
        size="xl"
      >

        <vue-html2pdf :show-layout="false" :float-layout="false" :enable-download="true"
          :preview-modal="true" :filename="licecount.customer_company.name +' (' + licecount.site.name + ') - Uke: ' +  licecount.week" 
          :manual-pagination="true" pdf-format="a4" pdf-content-width="95%" @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
          ref="html2Pdf">
          <section slot="pdf-content">

            <div class="html2pdf__page-break mt-4 pl-4">

                  <!-- Stats cards -->

          <b-row>

            <b-col>
              <b-card>
               <label>Antall fisk</label><h3>{{ details.fish.length }}</h3>
               </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Hunnlus</label><h3>{{ details.lice_female | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Bevegelige</label><h3>{{ details.lice_moving | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Fastsittende</label><h3>{{ details.lice_persist | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Skottelus</label><h3>{{ details.lice_skott | numeralFormat("0,0[.]00") }}</h3>
            </b-card>
            </b-col>

            <!-- <b-col>
              <b-card>
               <label>Velferd</label><h3>{{ details.wellfare  | numeralFormat("0,0[.]0") }} </h3>
               </b-card>
            </b-col> -->


          </b-row>

           <h6>Telling oversikt</h6>
                <b-table class="mt-3" v-if="this.details.fish[0] != null" :fields="fishFields"
                  :items="this.details.fish">

                  <template v-slot:cell(number)="data">
                    {{ data.value }}
                  </template>

                  <template v-slot:cell(cages)="data">{{
                          data.item.from_cage
                        }} <span v-if="data.item.to_cage != ''"> - {{
                          data.item.to_cage
                        }} </span> </template>

              <template v-slot:cell(wellfare)="data">

                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 1" variant="light">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 2" variant="warning">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 3" variant="danger">Risttap</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 1" variant="light">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 2" variant="warning">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 3" variant="danger">Rødbuk</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 1" variant="light">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 2" variant="warning">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 3" variant="danger">Sår</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 1" variant="light">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 2" variant="warning">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 3" variant="danger">Øyeblødning</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 1" variant="light">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 2" variant="warning">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 3" variant="danger">Finner</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds == 1" variant="light">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 2" variant="warning">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 3" variant="danger">Snutesår</b-badge>

                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds == 1" variant="light">Gjellelokkskade</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds  == 2" variant="warning">Gjellelokkskade</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillwounds  == 3" variant="danger">Gjellelokkskade</b-badge>

                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed == 1" variant="light">Gjelleblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed  == 2" variant="warning">Gjelleblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_gillbleed  == 3" variant="danger">Gjelleblødning</b-badge>

              </template>


                  <template v-slot:cell(fishcount)="data">
                    {{ data.value | numeralFormat("0,0[.]") }}
                  </template>

                  <template v-slot:cell(actions)="">
                   
                  </template>

            </b-table>

            </div>


          </section>
        </vue-html2pdf>

          <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="generateReport()"
            >
              Last ned rapport
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeLicecount()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
         </b-modal>
          

  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";

import {debounce } from "lodash";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { VueOffline, VueOfflineStorage } from 'vue-offline'



var dayjs = require('dayjs')
var weekOfYear = require('dayjs/plugin/weekOfYear')
dayjs.extend(weekOfYear)


export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
    VueTypeaheadBootstrap,
    
    VueOfflineStorage,
    VueOffline
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    networkStatus () {
            return this.isOnline ? 'My network is fine' : 'I am offline'
        }
  },
  data() {
    return {
      user: {},
      licecount: {},
      fish: {
        wellfare: 0,
        lice_persist: 0,
        lice_moving: 0,
        lice_female: 0,
        lice_skott: 0,
        fish_shelloss: 0,
        fish_redbelly: 0,
        fish_wounds: 0,
        fish_eyebleed: 0,
        fish_fin: 0,
        fish_nosewounds: 0,
        fish_gillbleed: 0,
        fish_gillwounds: 0
       },
      details: {
        fish: []
      },
      order: {},
      orders: [],
      customer_company: {},
      supplier_company: {},
      companies: [],
      site: {},
      sites: [],
      queryOrders: "",
      queryCompany: "",
      querySites: "",
      companyId: "",
      isLoading: false,
      offlineAlert: false,
      offlineData: false,
      fishFields: [{
        key: "number",
        label: "Fisk nummer",
        sortable: true,
      },
      {
        key: "lice_female",
        label: "Hunnlus",
        sortable: true,
      },
      {
        key: "lice_moving",
        label: "Bevegelige",
        sortable: true,
      },
      {
        key: "lice_persist",
        label: "Fastsittende",
        sortable: true,
      },
      {
        key: "lice_skott",
        label: "Skottelus",
        sortable: true,
      },
      {
        key: "wellfare",
        label: "Velferd",
        sortable: true,
      },
      {
        key: "note",
        label: "Notat",
        sortable: false,
        tdClass: "notemaxwidth",
      },
      {
        key: "actions",
        label: "",
        sortable: false,
      },
    ],
    typeLicecount: [
      { value: 'Inn telling', text: 'Inn telling' },
      { value: 'Ut telling', text: 'Ut telling' },
      ],
    };
  },
  props: ["id"],
  methods: {
    getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.supplier_company = res.data.company;
        });
    },
    getLicecount() {

        this.isLoading = true;
        
          // Save licecount online

            axios.get(`https://api.eines-as.no/licecounts/${this.id}`)

                .then((response) => {
                  console.log(response.data)
                  this.licecount = response.data;
                  this.details = response.data.details
                  this.fish.number = this.licecount.number

                  this.isLoading = false;
                  
                }) 
    },
    saveLicecount() {

      this.isLoading = true;

        // Save licecount online

         if (this.isOnline) {

              this.offlineAlert = false

              this.licecount.cage =  this.licecount.cage.toString()
              this.licecount.details = this.details

              axios.put("https://api.eines-as.no/licecounts/" + this.licecount.id , this.licecount)
                .then((response) => {
                  console.log(response.data)
                  this.$router.push("/dashboard/licecount");
                  this.isLoading = false;
                })
                .catch(function (error) {
                  console.log(error);
                  this.isLoading = false;
                });
 
            } 
            
             // Save licecount offline
            
            else {

              this.isLoading = true;

              this.offlineAlert = false

              this.licecount.cage =  this.licecount.cage.toString()
              this.licecount.details = this.details

              this.$offlineStorage.set('licecount',  this.licecount)
              this.offlineAlert = true
              this.offlineData = true
              
              this.isLoading = false;

            }

    },
    updateLicecount() {

      this.isLoading = true;

        // Update licecount

        if (this.isOnline) {

        this.offlineAlert = false

        this.licecount.cage =  this.licecount.cage.toString()
        this.licecount.details = this.details

        axios.put("https://api.eines-as.no/licecounts/" + this.licecount.id , this.licecount)
          .then((response) => {
            //this.$router.push("/dashboard/licecount");
            this.closeLicecount()
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });

       } 
     
       // Save licecount offline
            
       else {

        this.isLoading = true;

        this.offlineAlert = false

        this.licecount.cage =  this.licecount.cage.toString()
        this.licecount.details = this.details

        this.$offlineStorage.set('licecount',  this.licecount)
        this.offlineAlert = true
        this.offlineData = true
        
        this.isLoading = false;
      }
        
    },
    deleteLicecount() {

      this.isLoading = true;

        // Delete licecount
        
        axios.delete("https://api.eines-as.no/licecounts/" + this.licecount.id)
          .then((response) => {
            this.$router.push("/dashboard/licecount");
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
        
    },
    getOrders() {
        this.isLoading = true;
        var company = localStorage.getItem("company");

        axios
          .get("https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" + company)
          .then((response) => {
            this.orders = response.data;
            var ordersArray = []

            this.orders.forEach(order => {
                var orderObject = {
                  id: order.id,
                  number: order.ordernumber,
                  customer_company: order.customer_company,
                  supplier_company: order.supplier_company,
                  site: order.site,
                  label: order.ordernumber + " - " + order.customer_company.name + " (" + order.site.name + ")"
                }
                ordersArray.push(orderObject)
              })

            this.orders = ordersArray
            this.isLoading = false;
          });
    },

    getCompanies() {
      this.isLoading = true;

      axios
        .get("https://api.eines-as.no/companies")
        .then((res) => {
          this.companies = res.data;
          this.isLoading = false;
        });
    },
    getSites() {
      this.isLoading = true;

      axios
        .get("https://api.eines-as.no/sites")
        .then((res) => {
          this.sites = res.data;
          this.isLoading = false;
        });
    },
    addFish() {

        // Calculate average licecount
        this.fish.wellfare = (this.fish.fish_shelloss + this.fish.fish_redbelly + this.fish.fish_wounds + this.fish.fish_eyebleed + this.fish.fish_fin +  this.fish.fish_nosewounds)
        
        this.details.fish.push(this.fish);
        //this.details.fishcount = this.cage.biomass / this.cage.averageweight;

        this.licecount.number ++;  

        this.fish = {
          number: this.licecount.number,
          lice_persist: 0,
          lice_moving: 0,
          lice_female: 0,
          lice_skott: 0,
          fish_shelloss: 0,
          fish_redbelly: 0,
          fish_wounds: 0,
          fish_eyebleed: 0,
          fish_fin: 0,
          fish_nosewounds: 0,
          fish_gillbleed: 0,
          fish_gillwounds: 0
        }
              
       // Calculate average lice persist
           this.details.lice_persist = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_persist;
            }, 0) / this.details.fish.length;

       // Calculate average lice moving
           this.details.lice_moving = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_moving;
            }, 0) / this.details.fish.length;

       // Calculate average lice female
           this.details.lice_female = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_female;
            }, 0) / this.details.fish.length;

         // Calculate average lice skott
           this.details.lice_skott = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_skott;
            }, 0) / this.details.fish.length;

         // Calculate fish wellfare score
           this.details.wellfare = this.details.fish.reduce(function (average, fish) {
                return average + fish.wellfare;
            }, 0) / this.details.fish.length;


          this.updateLicecount()


      },
      removeFish(fish) {
        let index = this.details.fish.indexOf(fish);
        this.details.fish.splice(index, 1);


       // Calculate average lice persist
           this.details.lice_persist = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_persist;
            }, 0) / this.details.fish.length;

       // Calculate average lice moving
           this.details.lice_moving = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_moving;
            }, 0) / this.details.fish.length;

       // Calculate average lice female
           this.details.lice_female = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_female;
            }, 0) / this.details.fish.length;

         // Calculate average lice skott
           this.details.lice_skott = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_skott;
            }, 0) / this.details.fish.length;

         // Calculate fish wellfare score
           this.details.wellfare = this.details.fish.reduce(function (average, fish) {
                return average + fish.wellfare;
            }, 0) / this.details.fish.length;

          this.updateLicecount()
      },
      changeOrder(order) {
        this.licecount.customer_company = order.customer_company
        this.licecount.supplier_company = order.supplier_company
        this.site = order.site
      },
      openReport() {
         this.$bvModal.show("reportLicecountModal");
      },
      generateReport() {
        this.isLoading = true;
        this.$refs.html2Pdf.generatePdf();
        this.$bvModal.hide("reportLicecountModal");
        this.isLoading = false;
      },
      editLicecount() {
         this.getOrders()
         this.$bvModal.show("editLicecountModal");
      },
      closeLicecount() {
      this.$bvModal.hide("editLicecountModal");
      }, 
      uploadOfflineStorage() {
        this.licecount =  this.$offlineStorage.get('licecount')
        this.offlineData = false
        this.updateLicecount()
      },
      clearOfflineStorage() {
        this.$offlineStorage.removeItem('licecount')
        this.offlineData = false
      },
      goBack() {
        this.$router.push("/dashboard/licecount");
      },
      lookupOrders: debounce(function () {
        // Search and lookup companies from API

        var company = localStorage.getItem("company");

        axios
          .get("https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" + company)
          .then((response) => {
            this.orders = response.data;

          });
      }, 250),
      lookupCompanies: debounce(function () {
        // Search and lookup companies from API
        axios
          .get(`https://api.eines-as.no/companies?_q=${this.queryCompany}`)
          .then((response) => {
            this.companies = response.data;
          });
      }, 250),
      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 250),
  },
  created: function () {
    this.getUser()
    this.getLicecount()
  },
  
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.flscellmaxwidth {
  max-width: 300px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}

.table .table-success,
.table .table-success > th,
.table .table-success > td {
  background-color: #e4fae9;
}
</style>